/**
 * Marketplace / ad-platform registry.
 * Amazon is live today; others are scaffolded for future integrations.
 */

export const PLATFORMS = {
  amazon: {
    id: 'amazon',
    name: 'Amazon',
    shortName: 'Amazon',
    status: 'active',
    description: 'Amazon Advertising (SP, SB, SD)',
    connectType: 'oauth',
    regions: ['IN', 'US', 'UK', 'EU', 'AE', 'SA'],
    features: ['campaigns', 'keywords', 'bulk', 'reports', 'automation'],
    brandColor: '#FF9900',
    accentClass: 'orange',
    logo: '/platform-logos/amazon.svg',
    logoWordmark: '/platform-logos/amazon.svg',
  },
  flipkart: {
    id: 'flipkart',
    name: 'Flipkart',
    shortName: 'Flipkart',
    status: 'coming_soon',
    description: 'Flipkart Seller Ads',
    connectType: 'oauth',
    regions: ['IN'],
    features: ['campaigns', 'reports'],
    brandColor: '#2874F0',
    accentClass: 'blue',
  },
  blinkit: {
    id: 'blinkit',
    name: 'Blinkit',
    shortName: 'Blinkit',
    status: 'active',
    description: 'Blinkit quick-commerce ads',
    connectType: 'api_key',
    regions: ['IN'],
    features: ['campaigns', 'reports'],
    brandColor: '#F8CB46',
    accentClass: 'yellow',
    logo: '/platform-logos/blinkit.png',
  },
  zepto: {
    id: 'zepto',
    name: 'Zepto',
    shortName: 'Zepto',
    status: 'active',
    description: 'Zepto instant delivery ads & sales',
    connectType: 'api_key',
    regions: ['IN'],
    features: ['campaigns', 'reports', 'runs', 'data_health'],
    brandColor: '#7C3AED',
    accentClass: 'violet',
    logo: '/platform-logos/zepto.png',
  },
  instamart: {
    id: 'instamart',
    name: 'Instamart',
    shortName: 'Instamart',
    status: 'active',
    description: 'Swiggy Instamart ads & sales',
    connectType: 'api_key',
    regions: ['IN'],
    features: ['campaigns', 'reports', 'runs', 'data_health'],
    brandColor: '#F97316',
    accentClass: 'orange',
    logo: '/platform-logos/instamart.png',
  },
  bigbasket: {
    id: 'bigbasket',
    name: 'BigBasket',
    shortName: 'BigBasket',
    status: 'coming_soon',
    description: 'BigBasket marketplace reporting',
    connectType: 'api_key',
    regions: ['IN'],
    features: ['reports'],
    brandColor: '#84CC16',
    accentClass: 'lime',
  },
};

export const PLATFORM_LIST = Object.values(PLATFORMS);

export const ACTIVE_PLATFORMS = PLATFORM_LIST.filter((p) => p.status === 'active');

export const COMING_SOON_PLATFORMS = PLATFORM_LIST.filter((p) => p.status === 'coming_soon');

export function getPlatform(platformId = 'amazon') {
  return PLATFORMS[platformId] || PLATFORMS.amazon;
}

export function isPlatformActive(platformId) {
  return getPlatform(platformId).status === 'active';
}
